import { connect } from 'react-redux';
import {compose, hoistStatics, defaultProps, withHandlers, withState, lifecycle, withProps} from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Header from './Header';
import UserService from '../../services/user.service';
import ProfileService from '../../services/profile.service';
import fsh from '../../helpers/fromSubscriber.helper';
import dih from '../../helpers/defaultImages.helper';
import fh from '../../helpers/file.helper';
import mh from '../../helpers/messenger.helper';

const mapStateToProps = state => ({
  user: state.user.user,
  pageTitle: state.settings.pageTitle,
  enableCoverColor: state.settings.enableCoverColor,
  logo: state.settings.subscriber.logo,
  defaultCover: state.settings.subscriber.cover,
  modulesTypes: state.modules.modulesTypes,
  pageSubTitle: state.settings.pageSubTitle,
  backgroundPage: state.settings.backgroundPage,
  backgroundCover: state.settings.backgroundCover,
  pages: state.modules.pages,
  pagesSettings: state.modules.pagesSettings,
  customLinks: state.modules.customLinks,
  youtube: state.modules.youtube,
  vimeo: state.modules.vimeo,
  modules: state.modules.modulesSettings,
  messenger: state.messenger,
  token: state.auth.token,
});

const buttonCssClass = 'hamburger hamburger--squeeze';

const toggleMenu = props => async () => {
  const { menuIcon, setMenuIcon, setShowMenu } = props;
  const showMenu = menuIcon === buttonCssClass;
  await setMenuIcon(showMenu ? `${menuIcon} is-active` : buttonCssClass);
  await setShowMenu(showMenu);
  if (!showMenu && window.$('#mySidenav')[0]) {
    window.$('#mySidenav')[0].style.left = '-100%';
  }
};

const generateBackgroundImg = props => () => {
  const { backgroundCover, defaultCover } = props;
  const urls = [];
  let urlsStr = '';
  if (backgroundCover)urls.unshift(fh.createLink(backgroundCover));
  else if (defaultCover)urls.unshift(fh.createLink(defaultCover));
  else urls.push(dih.defaultCoverImgSettings);
  urls.forEach(item => urlsStr += `url("${item}"),`);
  urlsStr = urlsStr.substring(0, urlsStr.length - 1);
  urlsStr += ' center center no-repeat';
  return urlsStr;
};


class RefsStore {
  store(name, value) {
    this[name] = value;
  }
}

const enhance = compose(
  connect(mapStateToProps, null),
  translate('portal'),
  withState('menuIcon', 'setMenuIcon', buttonCssClass),
  withState('showMenu', 'setShowMenu', 0),
  withState('links', 'setLinks', []),
  defaultProps({
    getAvatar: UserService.getAvatar,
    getLogo: ProfileService.getLogo,
  }),
  withProps(props => ({
    countUnreadMessage: mh.getUnreadCountMessages(props.messenger),
    refs: new RefsStore(),
  })),
  withHandlers({
    toggleMenu,
    generateBackgroundImg,
  }),
  lifecycle({
    async componentDidMount() {
      const { setLinks } = this.props;
      const links = fsh.createNavLinks(this.props);
      setLinks(links);
    },
  }),
);

export default withRouter(hoistStatics(enhance)(Header));



// WEBPACK FOOTER //
// ./src/containers/header/index.js